import { render } from "./TabsWithBtn.vue?vue&type=template&id=d9089baa&scoped=true"
import script from "./TabsWithBtn.vue?vue&type=script&lang=js"
export * from "./TabsWithBtn.vue?vue&type=script&lang=js"

import "./TabsWithBtn.vue?vue&type=style&index=0&id=d9089baa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9089baa"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
